// #region 1. Create formData object
const formData = {
  email: '',
  message: '',
};
// #endregion

// #region 2. DOM Elements & Constants
const form = document.querySelector('.feedback-form');
const STORAGE_KEY = 'feedback-form-state';
// #endregion

// #region 3. Populate form from Local Storage on page load
// Check if we have saved data
const savedData = localStorage.getItem(STORAGE_KEY);

if (savedData) {
  try {
    // Parse JSON string back to object
    const parsedData = JSON.parse(savedData);

    // Update local formData object
    formData.email = parsedData.email || '';
    formData.message = parsedData.message || '';

    // Update DOM elements (visual fields)
    form.elements.email.value = formData.email;
    form.elements.message.value = formData.message;
  } catch (error) {
    console.error('Error parsing local storage data:', error);
  }
}
// #endregion

// #region 4. Listen to Input events (Event Delegation)
form.addEventListener('input', event => {
  // Get the name of the field (email or message) and its value
  const key = event.target.name;
  const value = event.target.value.trim(); // Trim spaces

  if (key) {
    // Update formData object
    formData[key] = value;

    // Save to Local Storage as a string
    localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
  }
});
// #endregion

// #region 5. Listen to Submit
form.addEventListener('submit', event => {
  event.preventDefault(); // Stop page reload

  // Validate: Check if fields are empty
  if (!formData.email || !formData.message) {
    alert('Fill please all fields');
    return;
  }

  // Output to console as requested
  console.log(formData);

  // Clear Local Storage
  localStorage.removeItem(STORAGE_KEY);

  // Reset internal object
  formData.email = '';
  formData.message = '';

  // Reset form visual fields
  form.reset();
});
// #endregion
